// src/components/common/Info.js
import React, { useState, useEffect } from 'react';
import apiClient from '../../api/client';

const Info = () => {
    const [announcements, setAnnouncements] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let isCancelled = false;
        const fetchAnnouncements = async () => {
            try {
                const data = await apiClient.getAnnouncements();
                if (!isCancelled) {
                    const announcementsWithVisibility = data.map(item => ({
                        ...item,
                        isVisible: true,
                        shouldAnimateOut: false,
                    }));
                    setAnnouncements(announcementsWithVisibility);
                }
            } catch (err) {
                if (!isCancelled) {
                    setError('Gagal memuat pengumuman.');
                    console.error('Error fetching announcements:', err);
                }
            } finally {
                if (!isCancelled) {
                    setIsLoading(false);
                }
            }
        };

        fetchAnnouncements();

        return () => {
            isCancelled = true;
        };
    }, []);

    const cleanHtml = (html) => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        return tempDiv.innerText.trim();
    };

    const handleClose = (id) => {
        const updatedAnnouncements = announcements.map(item =>
            item.id === id ? { ...item, shouldAnimateOut: true } : item
        );
        setAnnouncements(updatedAnnouncements);

        setTimeout(() => {
            const finalUpdatedAnnouncements = updatedAnnouncements.map(item =>
                item.id === id ? { ...item, isVisible: false } : item
            );
            setAnnouncements(finalUpdatedAnnouncements);
        }, 300);
    };

    if (isLoading) {
        return <div className="text-center text-gray-500">Memuat pengumuman...</div>;
    }

    if (error) {
        return <div className="text-center text-red-500">{error}</div>;
    }

    const visibleAnnouncements = announcements.filter(item => item.isVisible);

    if (visibleAnnouncements.length === 0 && !isLoading) {
        return <div className="text-center text-gray-500"></div>;
    }

    return (
        <div className="space-y-4">
            {visibleAnnouncements.map((item) => {
                const animationClasses = item.shouldAnimateOut
                    ? 'opacity-0 transform -translate-y-4'
                    : 'opacity-100 transform translate-y-0';

                return (
                    <div
                        key={item.id}
                        className={`bg-white p-6 rounded-lg shadow-md mx-auto my-6 flex items-start space-x-4 relative transition-all duration-300 ease-out ${animationClasses}`}
                    >
                        <div className="bg-blue-600 text-white font-bold text-xl w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0">
                            i
                        </div>
                        <div className="flex-grow pr-10">
                            <p className="font-semibold text-xl text-gray-800 mb-1">INFO!</p>
                            <p className="text-lg text-gray-600">{cleanHtml(item.pengumuman)}</p>
                        </div>
                        <button
                            className="absolute top-2 right-2 text-gray-400 hover:text-gray-800 text-2xl p-1 rounded-full hover:bg-gray-100 transition-colors"
                            onClick={() => handleClose(item.id)}
                        >
                            &times;
                        </button>
                    </div>
                );
            })}
        </div>
    );
};

export default Info;